import React, { Component } from "react";
import PropTypes from "prop-types";
import DonutChart from "react-donut-chart";
import { Divider, Tabs } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import WidgetCard from "../widget/card";

const TabPane = Tabs.TabPane;

class BoxChart extends Component {
  static propTypes = {
    classOverlay: PropTypes.string,
    dataChart1: PropTypes.array,
    dataChart2: PropTypes.array,
    isFooter: PropTypes.bool,
    isSpinner: PropTypes.bool,
    keyCanvas: PropTypes.string,
    perc: PropTypes.string,
    tabTitle1: PropTypes.string,
    tabTitle2: PropTypes.string,
    tabbed: PropTypes.bool,
    title: PropTypes.node,
    total1: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    total2: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  };

  componentDidMount() {
    let legendToCustomize = document.getElementsByClassName("overlapDonut-legend-item-label");
    for (let item in legendToCustomize) {
      if (item === "length") continue;
      legendToCustomize[item].innerHTML = legendToCustomize[item].innerHTML ? legendToCustomize[item].innerHTML.split("-")[0] : null;
    }
  }
  componentDidUpdate() {
    let legendToCustomize = document.getElementsByClassName("overlapDonut-legend-item-label");
    for (let item in legendToCustomize) {
      if (item === "length") continue;
      legendToCustomize[item].innerHTML = legendToCustomize[item].innerHTML ? legendToCustomize[item].innerHTML.split("-")[0] : null;
    }
  }
  renderChart(idCount, dataChart) {
    const { isFooter, isSpinner } = this.props;
    return (
      <div>
        {isSpinner ? (
          <div
            style={{
              textAlign: "center",
              fontSize: "55px",
              color: "#2184C2"
            }}
          >
            <FontAwesomeIcon icon={["far", "circle-notch"]} style={{ fontSize: "23px" }} spin />
          </div>
        ) : (
          <div className="force310">
            <DonutChart
              data={dataChart}
              width={380}
              height={270}
              strokeColor="transparent"
              className="overlapDonut"
              formatValues={(values, total) => `${Math.round(values).toLocaleString("it-IT")}`}
              colors={["#27A0D7", "#216AAE", "#E9397A", "#5CD7FF", "#7B36E8"]}
              colorFunction={(colors, index) => colors[index % colors.length]}
              innerRadius={0.75}
            />
            {isFooter ? this.renderFooter() : null}
          </div>
        )}
      </div>
    );
  }

  renderFooter() {
    const { total1, total2, perc } = this.props;
    return (
      <div>
        <Divider className="chartDivider" />
        <div style={{ padding: "0 10px" }}>
          <div>
            <div className="boxFooterHowMuch">
              {" "}
              {Math.round(total1).toLocaleString("it-IT")}€<br /> <span style={{ color: "#9b9b9b", fontSize: "16px" }}>{new Date().getFullYear()}</span>
            </div>
            <div className="boxFooterHowMuch" style={{ textAlign: "right", color: "#888" }}>
              {" "}
              {Math.round(total2).toLocaleString("it-IT")}€<br /> <span style={{ color: "#9b9b9b", fontSize: "16px" }}>{new Date().getFullYear() - 1}</span>
            </div>
          </div>
          <div className="boxDifferencePerc"> {perc !== "0" ? Math.round(perc) + "%" : "- %"} </div>
        </div>
      </div>
    );
  }
  render() {
    const { title, tabbed, dataChart1, dataChart2, tabTitle1, tabTitle2 } = this.props;
    return (
      <WidgetCard type={"box1_3 revenuesBox"} titleWidget={title} footer={null} isCentered={false}>
        <span
          style={{
            color: "#2A9DD6",
            fontSize: "30px",
            fontWeight: "300"
          }}
        />
        {tabbed ? (
          <Tabs>
            <TabPane tab={tabTitle1} key="1">
              {this.renderChart(1, dataChart1)}
            </TabPane>
            <TabPane tab={tabTitle2} key="2">
              {this.renderChart(2, dataChart2)}
            </TabPane>
          </Tabs>
        ) : (
          this.renderChart(1, dataChart1)
        )}
      </WidgetCard>
    );
  }
}
export default BoxChart;
